import type { TeamConfig } from '@jw-av/content'

interface RoleFocusChipsProps {
  team: TeamConfig
  activeRole: string
  onRoleChange: (role: string) => void
}

export function RoleFocusChips({ team, activeRole, onRoleChange }: RoleFocusChipsProps) {
  return (
    <div className="role-filter">
      <span className="role-filter__label">Focus</span>
      <div className="role-filter__chips">
        <button
          type="button"
          className={`role-chip ${activeRole === 'all' ? 'role-chip--active' : ''}`}
          onClick={() => onRoleChange('all')}
        >
          All roles
        </button>
        {team.roles.map((r) => (
          <button
            key={r.id}
            type="button"
            className={`role-chip ${activeRole === r.id ? 'role-chip--active' : ''}`}
            onClick={() => onRoleChange(r.id)}
          >
            {r.label}
          </button>
        ))}
      </div>
    </div>
  )
}
